import React from 'react';
import { ListGroupItem } from "react-bootstrap";


const Contact = (props) => {
  const contact = props.contact ? props.contact : null;
  if (!contact) {
    return (
      <div>loading...</div>
    )
  }

  return (
    <div>
      <ListGroupItem
        header={contact._source.nameFull + " --- " + contact._source.emailAddress}
        href={`/timeline/${contact._source.contactId}`}
        key={contact._source.contactId}
        onClick={props.click}
      >
        {"last contact: " + new Date(contact._source.appTimestamp).toLocaleString()}
      </ListGroupItem>
    </div>
  );
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/Contacts/Contact.js